<template>
  <modal
    name="modal-card"
    class="auth-modal"
    width="500px"
    height="360px"
    :adaptive="true"
    :clickToClose="false"
  >
    <Login />
  </modal>
</template>

<script>
import Login from '../Login';

export default {
  name: 'ModalCard',

  components: {
    Login,
  },
  methods: {
    hide() {
      this.$modal.hide('modal-card');
    },
  },
};
</script>

<style lang="scss">
[data-modal='registration-form'] .v--modal,
[data-modal='modal-card'] .v--modal {
  background-color: #042d64e8 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  &-form {
    width: 335px;
  }
  &-label {
    display: block;
    padding: 0 10px 10px;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.024em;
    color: #fff;
    text-align: center;
  }
  &-input {
    margin-bottom: 15px;
    input {
      border: none;
      outline: none;
      background-color: #fff;
      border-radius: 10px;
      padding: 16px 25px;
      font-size: 18px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 100%;
    }
  }
  &-buttons {
    display: flex;
    flex-wrap: nowrap;
  }
  &-button {
    margin: 0 15px 0 0;
    height: 56px;
    border-radius: 10px;
    border: 1px solid #fff;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #fff;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 10px;
    text-align: center;
    justify-content: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    flex: 1;
    &:last-of-type {
      margin-right: 0;
    }
    &-primary {
      background-color: #0d76ff;
      border-color: transparent;
    }
  }
}

@media only screen and (max-width: 480px) {
  .auth-modal .v--modal {
    width: calc(100% - 50px) !important;
    min-height: 410px !important;
    max-height: calc(90vh - 60px);
    height: auto !important;
    margin: 0 25px !important;
    top: 120px !important;
    overflow-x: hidden;

    &-form {
      width: 100% !important;
    }
  }
}
</style>
